import { TipoArquivoFilter } from './tipo-arquivo-filter';

export class TipoArquivoFilterStorage {
    filter: TipoArquivoFilter;
    filterValues: Map<string, any>;

    constructor(filter: TipoArquivoFilter) {
        this.filter = filter;
        this.filterValues = new Map();
    }
}
